import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .step-income__add-additional-source {
    display: block;
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    margin-top: 1.5em;
    text-align: center;
    text-decoration: none;
  }

  .button-container-iconic {
    text-align: center;
  }

  .fs-button-iconic.next-button {
    margin-top: 1.5em;
  }

  @media (width <= 48em) {
    .fs-button-iconic.next-button {
      min-width: 100%;
    }
  }
`;
